import React from 'react';

import { CommonStyles } from '~src/common/react/CommonStyles';
import { L10n } from '~src/ts/L10n/L10n';
import { MapperHelper } from '~src/ts/mappers/MapperHelper';

import { Messages } from '../../../codegen/Localize';
import { DatasourceEntity } from '../../../datasource/components/tooltips/DatasourceEntity';
import { IDataSourceInfo, IPublishedDatasourceInfoProperties } from '../../../datasource/models/IDataSourceInfo';
import { CommonDatasourceInfo} from '../../../datasource/models/mappers/CommonDatasourceInfo';
import { DataSources } from '../../../datasource/resources/Datasources';
import { ConnectionDisplay } from '../ListView/DataConnectionComponents';
import { EntityLinkProps } from './Elements/EntityLink';
import { Heading} from './Elements/Name';
import { DatasourceTooltip } from './Elements/Tooltip';
import { StatusTooltipProps} from './TooltipHelper';


let metadata: ConnectionDisplay.Metadata;
let publishedDSMessage: string;
let publishedconnectionMessage: string;
let embeddedDSMessage: string;
let embeddedConnectionMessage: string;
let publishedDetails: IPublishedDatasourceInfoProperties;
let publishedIcon: string;
let isPublished: boolean;
let isWorkbookPlace: boolean;
let hasEmbeddedExtract: boolean;
let hasPublishedExtract: boolean;
let published_bold_style: boolean;
let embedded_bold_style: boolean;

export function StatusToolTip(props: StatusTooltipProps): JSX.Element {
  if (!props.content.connectionDetails) {
    return null;
  }

  const datasource = props.content as IDataSourceInfo;
  metadata = ConnectionDisplay.getDisplayMetadata(props.content,props.urls);
  const M = MapperHelper;
  publishedDetails = datasource.publishedDatasourceDetails;
  isPublished = publishedDetails? true:false;
  const embeddedIcon = DataSources.getIconForDatasourceType(props.content as CommonDatasourceInfo,'tooltip');
  hasPublishedExtract = isPublished && (publishedDetails.hasExtracts === true);
  hasEmbeddedExtract = (datasource.hasExtracts === true);
  isWorkbookPlace = props.isWorkbookPlace? true: false;



  if(isPublished){
    getPublishedDsContent();
    publishedIcon = DataSources.getIconPathforPublished(publishedDetails.hasExtracts,false,'tooltip');}
  else{
      publishedIcon = metadata.iconImageUrl;
      publishedconnectionMessage = undefined;
      if(datasource.connectionDetails.type === 'file'){
        publishedDSMessage = datasource.connectionTypeDisplayName;}
      else {
        publishedDSMessage = Messages.embeddedDatabaseConnection({CONNECTION_TYPE: datasource.connectionTypeDisplayName});}
  }

  getEmbeddedDsContent(props.content,);
  if(hasEmbeddedExtract && hasPublishedExtract){
    if(M.toDate(publishedDetails.lastRefreshedAt).valueOf() > datasource.lastRefreshedAt.valueOf()){
      embedded_bold_style = true;
      published_bold_style = false;
      embeddedConnectionMessage = embeddedConnectionMessage+' '+Messages.oldestRefresh();
    }
    else{
      published_bold_style = true;
      embedded_bold_style = false;
      publishedconnectionMessage = publishedconnectionMessage+' '+Messages.oldestRefresh();
    } }
else{
    embedded_bold_style = hasEmbeddedExtract;
    published_bold_style = hasPublishedExtract;}

  const published = getRelatedDatasourceLinkProps(metadata.connectionName,publishedIcon,metadata.href,17,false,props.federatedCount);
  const embedded = getRelatedDatasourceLinkProps(datasource.name,embeddedIcon,undefined,17,true);
  return (
    <DatasourceTooltip>
      <Heading name={Messages.extractStatusLabelTitle()+':'} />
      {<DatasourceEntity link = {published} fileType={publishedDSMessage} connectionDetails={publishedconnectionMessage} bold={published_bold_style} index={0}/>}
      {<DatasourceEntity link = {embedded} fileType={embeddedDSMessage} connectionDetails={embeddedConnectionMessage} bold={embedded_bold_style} index={1}/>}
    </DatasourceTooltip>
  );
}

export const HyperLinkStyle: React.CSSProperties = {
  fontWeight: 'bold',
  color: CommonStyles.Colors.HyperlinkBlue,
  marginLeft: '34px'
};

export const TextStyle: React.CSSProperties = {
  fontWeight: 'bold',
  color: CommonStyles.Colors.NormalTextColor,
  marginLeft: '34px'
};

const MissingNameStyle: React.CSSProperties =
{ fontStyle: 'italic',
  color: CommonStyles.Colors.Grey178,
  marginLeft: '34px'
};

function getRelatedDatasourceLinkProps(datasourceName: string,iconImagePath: string,href: string,height: number, background: boolean, federatedCount?: number): EntityLinkProps {
  return {
    name: (datasourceName === '') ? Messages.filenameUnavailable() : federatedCount>0 ? datasourceName+'+'+federatedCount : datasourceName,
    href: href,
    iconImagePath: iconImagePath,
    iconHeightOverride: height,
    textStyleOverride: (datasourceName === '')? MissingNameStyle: href? HyperLinkStyle: TextStyle,
    iconStyle: true,
    background: background
  };
}

function getPublishedDsContent() {
  if(publishedDetails.hasExtracts) {
    publishedDSMessage = publishedDetails.hasEncryptableExtracts ? Messages.encryptedExtractPublished({ENCRYPTION_STATE: publishedDetails.extractEncryptionState}) : Messages.datasourcePublished({LIVE_OR_EXTRACT:Messages.extract()});
    publishedconnectionMessage = Messages.lastRefreshed()+' '+L10n.localizedDateTime(publishedDetails.lastRefreshedAt);
    return;}
  publishedDSMessage = Messages.datasourcePublished({LIVE_OR_EXTRACT:Messages.live()});
  publishedconnectionMessage = undefined;
}

function getEmbeddedDsContent(datasource: IDataSourceInfo) {
  if(datasource.hasExtracts){
    if(datasource.hasEncryptableExtracts){
      let encryptionState= datasource.extractEncryptionState.charAt(0).toUpperCase()+datasource.extractEncryptionState.substring(1);
      embeddedDSMessage = (datasource.connectedWorkbooksCount > 0 && isWorkbookPlace) ? Messages.encryptedExtractEmbedded({ENCRYPTION_STATE: encryptionState,UNICODE:String.fromCharCode(8212)}): Messages.encryptedExtractPublished({ENCRYPTION_STATE: encryptionState});}
    else{
      embeddedDSMessage = (datasource.connectedWorkbooksCount > 0 && isWorkbookPlace) ? Messages.datasourceEmbedded({LIVE_OR_EXTRACT:Messages.extract(),UNICODE:String.fromCharCode(8212)}): Messages.datasourcePublished({LIVE_OR_EXTRACT:Messages.extract()});}
    embeddedConnectionMessage = Messages.lastRefreshed()+' '+L10n.localizedDateTime(datasource.lastRefreshedAt);
    return;
  }
  embeddedDSMessage= (datasource.connectedWorkbooksCount > 0 && isWorkbookPlace) ? Messages.datasourceEmbedded({LIVE_OR_EXTRACT:Messages.live(),UNICODE:String.fromCharCode(8212)}): Messages.datasourcePublished({LIVE_OR_EXTRACT:Messages.live()});
  embeddedConnectionMessage= undefined;
}


